import {isQQ, isEmail, isTelpehone} from '@src/utils/common';
import Constant, {QUESTION_TYPES} from '@src/utils/constant';
import isIdentityId from '@src/utils/isIdentityId';
import i18n from '@src/i18n';

const {
  FILL,
  SINGLE_CHOICE,
  MULTIPLE_CHOICE,
  AREA,
  LOCATION,
  NUMBER,
  DATE,
  PERSON,
  DEPARTMENT,
  MATRIX_SINGLE_CHOICE,
  MATRIX_FILL,
  PICTURE,
  SIGNATURE,
  SCORE,
  ATTACHMENT,
  TRIP_CODE,
  ORCIDENTIFY,
  OCRIDENTIFYHEALTHCODE
} = QUESTION_TYPES;
export const numberRegTest = (answer, question) => {
  const ps = question.properties || [];
  const numberItem = ps.find(item => item.propertyKey === Constant.NUMBER_TYPE);
  const fillNumberItem = ps.find(item => item.propertyKey === Constant.FILL_TYPE);
  const numberReg = /(\d$)/g;

  if (numberItem) {
    const value = numberItem.propertyValue;
    if (value == Constant.TEMPERATURE) {
      // 体温
      if (answer.answerContent < 35 || answer.answerContent > 42 || !numberReg.test(answer.answerContent)) {
        return i18n.t('weform:submitCountentTip');
      }
    } else if (value == Constant.OWNER) {
      // 自定义
      const verItem = ps.find(item => item.propertyKey === 'verification');
      // 开启位数校验
      if (verItem && verItem.propertyValue.toString() === 'true') {
        const checkNumber = ps.find(item => item.propertyKey === 'checkNumber');
        const checkMaxNumber = ps.find(item => item.propertyKey === 'checkMaxNumber');
        if (checkNumber) {
          const minNum = +checkNumber.propertyValue;
          const maxNum = +checkMaxNumber?.propertyValue || 38;
          const text = answer.answerContent.toString();
          if (text[text.length - 1] === '.') {
            return i18n.t('weform:inputCoorectDigits');
          }
          if (text.replace(/\./g, '').length < minNum) {
            if (minNum === maxNum) {
              return i18n.t('weform:numberDigits',{minNum:minNum});
            }
            return i18n.t('weform:numberDigitsInterval',{minLength:minNum, maxNum:maxNum});
          }
        }
      } else if (question.isRequired && !answer.answerContent.trim()) {
        return true;
      }
    }
  }

  if (fillNumberItem) {
    const value = fillNumberItem.propertyValue;
    // 手机
    if (value === Constant.PHONE) {
      const reg = /^1[3456789]\d{9}$/;
      if (!reg.test(answer.answerContent)) {
        return i18n.t('weform:pleaseInputCorrectPhoneNumber');
      }
    } else if (value === Constant.QQ_number) {
      if (!isQQ(answer.answerContent)) {
        return i18n.t('weform:pleaseInputQQ');
      }
    } else if (value === Constant.IDENTITY_ID) {
      if (!isIdentityId(answer.answerContent)) {
        return i18n.t('weform:pleaseInputIdCard');
      }
    } else if (value === Constant.MAIL_BOX) {
      if (!isEmail(answer.answerContent)) {
        return i18n.t('weform:pleaseInputEmail');
      }
    } else if (value === Constant.TELE_PHONE) {
      if (!isTelpehone(answer.answerContent)) {
        return i18n.t('weform:pleaseInputPhoneNumber');
      }
    } else if (value === Constant.NORMAL_TEXT) {
      if (answer.answerContent.trim().length === 0) {
        return i18n.t('weform:pleaseInput');
      }
    }
  }
};

export const numberValid = (question, i, answers, updateAnswer) => {
  const _answers = [...answers];
  i = answers.findIndex(answer => answer.questionId == question.questionId);
  if (question.isRequired) {
    if (numberRegTest(_answers[i], question)) {
      _answers[i].showMeBug = true;
    } else {
      _answers[i].showMeBug = false;
    }
  } else {
    if (answers[i].answerContent !== undefined && answers[i].answerContent !== null && String(answers[i].answerContent) !== '') {
      if (numberRegTest(_answers[i], question)) {
        _answers[i].showMeBug = true;
      } else {
        _answers[i].showMeBug = false;
      }
    } else {
      _answers[i].showMeBug = false;
    }
  }
  updateAnswer(_answers);
  return !_answers[i].showMeBug;
};

/**
 * 是否有选择其他选项
 * @param {当前校验的问题对戏} question
 * @param {当前选中的答案} answer
 * @returns true 为选中其他选项，false 为未选中其他选项
 */
 export const isFillOther = (question, answer) => {
  const otherOption = question?.options.find(option => option.isOther);
  answer.noFillOther = false;
  if (otherOption) {
    const hasSelectOther = answer.optionIds.includes(otherOption.optionId);
    if (hasSelectOther) {
      if (!answer.answerContent) {
        answer.noFillOther = true;
        return false;
      }
    }
  }
  return true;
};

export const mulValid = (question, i, answers, updateAnswer) => {
  const _answers = [...answers];
  i = answers.findIndex(answer => answer.questionId == question.questionId);
  _answers[i].showMeBug = false;
  if (question.isRequired) {
    // 所有必填题目没有文本答案和选项答案
    if (!answers[i].answerContent && answers[i].optionIds.length === 0) {
      _answers[i].showMeBug = true;
    } else {
      _answers[i].showMeBug = false;
    }
  }
  if (!isFillOther(question, answers[i])) {
    _answers[i].showMeBug = true;
  }
  // 判断多选题选中的个数
  if (question.questionType === 'multiple-choice' && answers[i].optionIds.length) {
    let mulQFlag = false;
    mulQFlag = handleMulqNum(question);
    if (mulQFlag) {
      const arr = min2max(question);
      const len = answers[i].optionIds.length;
      if (len < arr[0] || len > arr[1]) {
        _answers[i].showMeBug = true;
      } else {
        _answers[i].showMeBug = false;
      }
    }
  }

  updateAnswer(_answers);
  return !_answers[i].showMeBug;
};

export const handleMulqNum = question => {
  const ps = question.properties || [];
  const numItem = ps.find(item => item.propertyKey === 'switchMumChange');
  return numItem && numItem.propertyValue.toString() === 'true';
};

export const min2max = question => {
  const ps = question.properties || [];
  const maxItem = ps.find(item => item.propertyKey === 'maximum');
  const minItem = ps.find(item => item.propertyKey === 'minimum');
  return [minItem.propertyValue, maxItem.propertyValue];
};

export const matrixFillValid = (question, i, answers, updateAnswer) => {
  const _answers = [...answers];
  i = answers.findIndex(answer => answer.questionId == question.questionId);
  if (question.isRequired) {
    const answerContent = _answers[i].answerContent || [];
    if (!answerContent || Object.keys(answerContent).length === 0) {
      _answers[i].showMeBug = true;
    } else {
      // 定义X轴显示数据
      let xArias = [];

      xArias = question.children || [];

      // 定义可操作内容数组
      let arrs = [];

      for (let i = 0; i < xArias.length; i++) {
        let xAria = xArias[i];

        const options = xAria.options || [];
        options.forEach(option => {
          const obj = {
            questionId: xAria.questionId,
            questionType: xAria.questionType,
            optionId: option.optionId,
          };
          arrs.push(obj);
        });
      }
      if (arrs.length === answerContent.length) {
        _answers[i].showMeBug = false;
      } else {
        _answers[i].showMeBug = true;
      }
    }
  }
  updateAnswer(_answers);
  return !_answers[i].showMeBug;
};

export const areaValid = (question, i, answers, updateAnswer) => {
  const _answers = [...answers];
  i = _answers.findIndex(answer => answer.questionId == question.questionId);
  if (question.isRequired) {
    // 所有必填题目没有文本答案和选项答案
    if (!answers[i].answerContent && answers[i].optionIds.length === 0) {
      _answers[i].showMeBug = true;
    } else {
      _answers[i].showMeBug = false;
    }
  }
  // 地区题(要填写具体地址的)
  if (question.questionType === 'area') {
    const ps = question.properties || [];
    const areaItem = ps.find(item => item.propertyKey === 'inputType');
    if (areaItem && areaItem.propertyValue == '2') {
      const citys = answers[i].answerContent.citys;
      const detail = answers[i].answerContent.detail;

      if (question.isRequired) {
        if (!citys || (citys && citys.length === 0) || !detail) {
          _answers[i].showMeBug = true;
        } else {
          _answers[i].showMeBug = false;
        }
      } else {
        if (!citys && !detail) {
          _answers[i].showMeBug = false;
        } else if (citys && citys.length > 0 && detail) {
          _answers[i].showMeBug = false;
        } else {
          _answers[i].showMeBug = true;
        }
      }
    }
  }
  updateAnswer(_answers);
  return !_answers[i].showMeBug;
};

export const atherValid = (question, i, answers, updateAnswer) => {
  const regSpace = /(^\s*)|(\s*)$/g;
  const _answers = [...answers];
  i = _answers.findIndex(answer => answer.questionId == question.questionId);
  if (question.isRequired) {
    let isStringType = typeof answers[i].answerContent === 'string';
    let isHasAnswer = isStringType ? answers[i].answerContent.replace(regSpace, '') : answers[i].answerContent;
    // 所有必填题目没有文本答案和选项答案
    if (!isHasAnswer && answers[i].optionIds.length === 0) {
      _answers[i].showMeBug = true;
    } else {
      _answers[i].showMeBug = false;
    }
  }
  updateAnswer(_answers);
  return !_answers[i].showMeBug;
};

export const matrixSingleValid = (question, i, answers, updateAnswer) => {
  const _answers = [...answers];
  i = _answers.findIndex(answer => answer.questionId == question.questionId);
  if (question.isRequired) {
    if (question.children.length === _answers[i].optionIds.length) {
      _answers[i].showMeBug = false;
    } else {
      _answers[i].showMeBug = true;
    }
  }
  updateAnswer(_answers);
  return !_answers[i].showMeBug;
};

export const questionValids = {
  [FILL]: atherValid,
  [SINGLE_CHOICE]: atherValid,
  [MULTIPLE_CHOICE]: mulValid,
  [AREA]: areaValid,
  [LOCATION]: atherValid,
  [NUMBER]: numberValid,
  [DATE]: atherValid,
  [PERSON]: atherValid,
  [DEPARTMENT]: atherValid,
  [MATRIX_SINGLE_CHOICE]: matrixSingleValid,
  [MATRIX_FILL]: matrixFillValid,
  [PICTURE]: atherValid,
  [SIGNATURE]: atherValid,
  [SCORE]: atherValid,
  [ATTACHMENT]: atherValid,
  [TRIP_CODE]: atherValid,
  [ORCIDENTIFY]:atherValid,
  [OCRIDENTIFYHEALTHCODE]:atherValid,
  [QUESTION_TYPES.OCR_NUCLEICACID_CODE]:areaValid
};

export const validRequiredFill = (editQuestions, answers, questionValid) => {
  let newAnswers = null;
  let isValidFalse = true;
  let unfilledFirstIndex = -1;
  editQuestions?.map((questionItem, index) => {
    if (questionItem?.questionType !== 'description' && questionValid[questionItem?.questionType]) {
      const result = questionValid[questionItem?.questionType](questionItem, index, answers, answers => {
        newAnswers = answers;
      });
      if (!result) {
        isValidFalse = false;
        if (unfilledFirstIndex === -1) {
          unfilledFirstIndex = index;
        }
      }
    }
  });
  return { answers: newAnswers, isValidFalse, unfilledFirstIndex };
};

